<template>
  <div>
    <b-row class="align-items-center mb-3">
      <b-col cols="12" class="d-flex justify-content-end">
        <h-b-action
          text="Ajouter un dossier"
          :positive="false"
          icon="bx bx-plus"
          @click.native="addFolder(parentFolder)"
        ></h-b-action>
      </b-col>
    </b-row>
    <b-row v-if="loadedGet">
      <b-col cols="4" :style="windowSize">
        <h-fe-tree-menu
          :folders="folder.folders"
          :item="{ route: true }"
          :user-me="userMe"
          :actual-file-id="passActualId"
          class="pt-2"
          @clickFav="addRemoveFav"
          @clickDeleteFolder="deleteFolder"
          @clickAddFolder="addFolder"
          @clickEditFolder="prepareEditFolder"
          @clickSelectFile="manageSelectFile"
          @clickAddFile="note ? addFile($event) : prepareAddFile($event)"
        ></h-fe-tree-menu>
      </b-col>
      <b-col cols="8" class="border rounded">
        <div v-if="actualFile">
          <b-row class="py-2 px-2 border-bottom d-flex justify-content-between align-items-center">
            <div class="d-flex justify-content-between align-items-center w-100">
              <h-f-field-visualize
                v-if="note && actualFile.owner === userMe"
                :field="actualFile.name"
                style="width: 25% !important"
                @editEnd="editFile"
              >
                <template #form>
                  <h-f-fields v-model="actualFile.name" placeholder="Entrez un nom"></h-f-fields>
                </template>
                <template #visualize>
                  <h6 class="p-0 m-0">
                    {{ actualFile.name }}
                  </h6>
                </template>
              </h-f-field-visualize>
              <h6 v-else class="p-0 m-0">
                {{ actualFile.name }}
              </h6>
              <div>Crée par : {{ actualFile.owner_object.first_name }} {{ actualFile.owner_object.last_name }}</div>
              <h-b-dropdown
                v-if="dropdownChoices.length"
                nav-header="Actions"
                :nav-choices="dropdownChoices"
                style="width: 150px"
              ></h-b-dropdown>
              <div v-else></div>
            </div>
            <slot name="external-infos"></slot>
          </b-row>
          <b-row v-if="note" class="pt-2">
            <h-f-field-visualize v-if="actualFile.owner === userMe" :field="actualFile.text" @editEnd="editFile">
              <template #form>
                <h-f-fields
                  v-model="actualFile.text"
                  input-type="ckeditor"
                  placeholder="Écrivez une note..."
                ></h-f-fields>
              </template>
              <template #visualize>
                <div class="ml-2" :style="windowSize" v-html="actualFile.text"></div>
              </template>
            </h-f-field-visualize>
            <div v-else class="ml-2" :style="windowSize" v-html="actualFile.text"></div>
          </b-row>
          <b-row v-else class="pt-2 px-2">
            <iframe class="w-100" :src="actualFile.document" height="400"></iframe>
          </b-row>
        </div>
        <b-row v-if="note && !actualFile" class="no-notes">
          <h3 class="title">Consultez vos {{ report ? 'compte-rendus' : 'notes' }} à tout moment</h3>
          <img src="../../../assets/images/no-notes.svg" alt="no notes" style="width: 300px" />
        </b-row>
        <b-row v-if="!note && !actualFile" class="no-notes documents">
          <h3 class="title">Consultez vos documents à tout moment</h3>
          <img src="../../../assets/images/no-documents.svg" alt="no documents" style="width: 300px" />
        </b-row>
      </b-col>
    </b-row>
    <b-row v-else>
      <vue-content-loading :width="1920" :height="400" class="mb-5">
        <rect x="0" y="0" rx="0" ry="0" width="38%" height="100" />
        <rect x="0" y="120" rx="0" ry="0" width="38%" height="100" />
        <rect x="0" y="240" rx="0" ry="0" width="38%" height="100" />
        <rect x="40%" y="0" rx="0" ry="0" width="60%" height="400" />
      </vue-content-loading>
    </b-row>
    <h-f-slider
      v-model="sliderActive"
      title="Ajouter un dossier"
      :loaded="loadedPostFolder"
      @clickCancel="sliderActive = !sliderActive"
      @clickSubmit="submitFolder"
    >
      <h-f-fields v-model="folderForm.name" label="Nom du dossier"></h-f-fields>
    </h-f-slider>
    <vue-html2pdf
      v-if="actualFile && note"
      ref="html2Pdf"
      :filename="actualFile.name"
      :enable-download="true"
      :float-layout="true"
      :manual-pagination="false"
      :paginate-elements-by-height="2480"
      :pdf-quality="2"
      :show-layout="false"
      :preview-modal="true"
      pdf-content-width="100%"
      pdf-format="a4"
    >
      <section slot="pdf-content">
        <div class="w-100 html-to-pdf-section">
          <slot name="external-infos-pdf"></slot>
          <h1 class="w-100">
            {{ actualFile.name }}
          </h1>
          <div v-html="actualFile.text"></div>
        </div>
      </section>
    </vue-html2pdf>
    <h-pop-user-v2
      v-if="actualFile"
      ref="userManagerPop"
      v-model="actualFile.shared_users"
      :assigned-users-object="actualFile.shared_users_object"
      title="Gestion de partage du fichier"
      @change="manageMultipleUser"
    ></h-pop-user-v2>
    <b-modal v-model="addDocumentModal" size="lg">
      <vue-dropzone
        id="dropzone"
        ref="myVueDropzone"
        :use-custom-slot="true"
        :options="dropzoneOptions"
        @vdropzone-file-added="vFileAdded"
      >
        <div class="dropzone-custom-content">
          <i class="display-4 text-muted bx bx-cloud-download"></i>
          <h5>Choisir ou déposer un fichier</h5>
        </div>
      </vue-dropzone>
      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <h-b-action v-if="loadedPostDocuments" text="Valider" positive @click.native="submitDocuments"></h-b-action>
          <h-e-spinner v-else size="sm"></h-e-spinner>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import VueHtml2pdf from 'vue-html2pdf'
import vue2Dropzone from 'vue2-dropzone'
import VueContentLoading from 'vue-content-loading'

const { Folder, File } = Hk.Folder

export default {
  name: 'file-manager',

  components: {
    VueHtml2pdf,
    vueDropzone: vue2Dropzone,
    VueContentLoading,
  },

  props: {
    note: {
      type: Boolean,
      default: false,
    },
    parentFolder: {
      // doc_id or note_id
      type: String,
      default: '',
    },
    service: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    externalId: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'sm',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    report: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      folder: {},
      folderForm: Folder.get_form(),
      externalInfos: this.value,
      initialExternalInfos: JSON.parse(JSON.stringify(this.value)),
      sliderActive: false,
      loadedPostFolder: true,
      loadedGet: false,
      actualFile: null,
      userMe: JSON.parse(localStorage.getItem('user_object')).uuid,
      dropdownChoices: [],
      actualFolderId: null,
      addDocumentModal: false,
      documents: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 100,
        maxFilesize: 0.5,
        headers: { 'My-Awesome-Header': 'header value' },
      },
      loadedPostDocuments: true,
      htmlToPdfOptions: {
        margin: 10,
      },
    }
  },

  computed: {
    passActualId() {
      if (this.actualFile) {
        return this.actualFile.id
      }
      return ''
    },

    windowSize() {
      return `height: calc(100vh - ${this.size === 'sm' ? 450 : 250}px) ;overflow: auto`
    },
  },

  watch: {
    externalInfos: {
      deep: true,
      handler() {
        this.$emit('input', this.externalInfos)
      },
    },

    value: {
      deep: true,
      handler() {
        this.externalInfos = this.value
        this.actualFile.external_infos = this.externalInfos
        this.editFile()
      },
    },

    actualFile: {
      deep: true,
      handler() {
        if (this.actualFile && this.actualFile.external_infos) {
          this.externalInfos = this.actualFile.external_infos
        } else {
          this.externalInfos = JSON.parse(JSON.stringify(this.initialExternalInfos))
        }
      },
    },
  },

  async mounted() {
    await this.getFolders()
  },

  methods: {
    async getFolders() {
      this.loadedGet = false
      this.folder = await Folder.getById(this.parentFolder) // need to replace it with note_id
      this.formatFolders()
      this.loadedGet = true
    },

    formatDropdownChoices() {
      this.dropdownChoices = []
      if (this.note) {
        this.dropdownChoices.push({ text: 'Exporter PDF', icon: 'mdi mdi-share-outline', function: this.exportFile })
      }
      if (this.actualFile.owner === this.userMe) {
        this.dropdownChoices.push({ text: 'Partager', icon: 'mdi mdi-account-plus', function: this.openShareModal })
        this.dropdownChoices.push({ text: 'Supprimer', icon: 'bx bx-trash-alt', function: this.deleteFile })
      }
    },

    formatFolders() {
      let defaultFolderHash = null
      if (this.note && !this.report) {
        defaultFolderHash = Folder.get_default_note_folders()
      } else if (this.note && this.report) {
        defaultFolderHash = Folder.get_default_report_folders()
      } else if (!this.note) {
        defaultFolderHash = Folder.get_default_document_folders()
      }
      this.folder.files = this.folder.files.concat(this.getFiles(this.folder.folders, []))
      this.folder.files.forEach((file) => {
        defaultFolderHash.all.files.push(file)
        if (file.owner === this.userMe) {
          defaultFolderHash.my.files.push(file)
        }
        if (file.favorite_users.indexOf(this.userMe) >= 0) {
          defaultFolderHash.fav.files.push(file)
        }
        if (file.shared_users.indexOf(this.userMe) >= 0) {
          defaultFolderHash.shared.files.push(file)
        }
      })
      const defaultFolders = Object.keys(defaultFolderHash).map((key) => {
        return {
          ...defaultFolderHash[key],
          id: this.parentFolder,
          default: true,
        }
      })
      this.folder.folders = defaultFolders.concat(this.folder.folders)
    },

    getFiles(folders, files) {
      for (let i = 0; i < folders.length; i++) {
        if (folders[i].folders.length) {
          return this.getFiles(folders[i].folders, files.concat(folders[i].files))
        }
        // eslint-disable-next-line no-param-reassign
        files = files.concat(folders[i].files)
      }
      return files
    },

    async submitFolder() {
      this.loadedPostFolder = false
      if (this.folderForm.id) {
        const folderForm = { ...this.folderForm }
        delete folderForm.service_category
        Folder.patch(folderForm.id, { data: folderForm })
        this.folderForm = Folder.get_form()
      }
      this.sliderActive = false
      this.loadedPostFolder = true
    },

    async addFolder(folderId) {
      const parentFolder = this.findFolder(this.folder.folders, folderId)
      this.folderForm = Folder.get_form()
      this.folderForm.name = 'Nouveau dossier'
      this.folderForm.owner = this.userMe
      this.folderForm.type = this.note ? 'note' : 'doc'
      this.folderForm.service_category = this.service // project service
      this.folderForm.company = this.company

      if (folderId !== this.parentFolder) {
        if (parentFolder) {
          this.folderForm.parent =
            parentFolder.folders[parentFolder.folders.findIndex((folder) => folder.id === folderId)].id
          this.folderForm = await Folder.create(this.folderForm)
          parentFolder.folders[parentFolder.folders.findIndex((folder) => folder.id === folderId)].folders.push(
            this.folderForm,
          )
        } else {
          this.folderForm.parent = folderId
          this.folderForm = await Folder.create(this.folderForm)
          this.folder.folders[this.folder.folders.findIndex((folder) => folder.id === folderId)].folders.push(
            this.folderForm,
          )
        }
      } else {
        this.folderForm.parent = this.parentFolder
        this.folderForm = await Folder.create(this.folderForm)
        this.folder.folders.push(this.folderForm)
      }

      this.sliderActive = true
    },

    async addFile(folderId) {
      const fileForm = File.get_form()
      fileForm.name = 'Nouvelle note'
      fileForm.type = 'note'
      fileForm.service_category = '00000000-0000-0000-0000-000000000005' // TODO need to replace it with this.service
      fileForm.external_id = this.externalId
      fileForm.folder_parent = folderId
      fileForm.owner = this.userMe

      const newFile = await File.create(fileForm)

      if (folderId !== this.parentFolder) {
        this.folder.folders[this.folder.folders.findIndex((folder) => folder.label === 'all')].files.push(newFile)
      }
      this.folder.folders[this.folder.folders.findIndex((folder) => folder.label === 'my')].files.push(newFile)

      const parentFolder = this.findFolder(this.folder.folders, folderId)
      if (parentFolder) {
        parentFolder.folders[parentFolder.folders.findIndex((folder) => folder.id === folderId)].files.push(newFile)
      } else {
        this.folder.folders[this.folder.folders.findIndex((folder) => folder.id === folderId)].files.push(newFile)
      }

      this.actualFile = newFile
    },

    prepareAddFile(folderId) {
      this.actualFolderId = folderId
      this.addDocumentModal = true
    },

    async vFileAdded(file) {
      const fileForm = File.get_form()
      fileForm.type = 'document'
      fileForm.name = file.name
      fileForm.owner = this.userMe
      fileForm.folder_parent = this.actualFolderId
      fileForm.size = (file.size / 10 ** 6).toFixed(1)
      fileForm.service_category = '00000000-0000-0000-0000-000000000005' // TODO need to replace it with this.service
      fileForm.external_id = this.externalId
      fileForm.document = await this.vFileAddedPromise(file)
      this.documents.push(fileForm)
    },

    async vFileAddedPromise(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (event) => {
          resolve(event.target.result)
        }

        reader.onerror = reject

        reader.readAsDataURL(file)
      })
    },

    async submitDocuments() {
      this.loadedPostDocuments = false
      // eslint-disable-next-line no-restricted-syntax
      for (const document of this.documents) {
        // eslint-disable-next-line no-await-in-loop
        const file = await File.create(document)
        if (this.actualFolderId !== this.parentFolder) {
          this.folder.folders[this.folder.folders.findIndex((folder) => folder.label === 'all')].files.push(file)
        }
        this.folder.folders[this.folder.folders.findIndex((folder) => folder.label === 'my')].files.push(file)

        const parentFolder = this.findFolder(this.folder.folders, this.actualFolderId)
        if (parentFolder) {
          parentFolder.folders[
            parentFolder.folders.findIndex((folder) => folder.id === this.actualFolderId)
          ].files.push(file)
        } else {
          this.folder.folders[this.folder.folders.findIndex((folder) => folder.id === this.actualFolderId)].files.push(
            file,
          )
        }
      }
      this.documents = []
      this.$refs.myVueDropzone.removeAllFiles()
      this.addDocumentModal = false
      this.loadedPostDocuments = true
    },

    manageSelectFile(fileId) {
      const allFolderIndex = this.folder.folders.findIndex((folder) => folder.label === 'all')
      this.actualFile =
        this.folder.folders[allFolderIndex].files[
          this.folder.folders[allFolderIndex].files.findIndex((file) => file.id === fileId)
        ]
      if (!this.actualFile.text) {
        this.actualFile.text = ''
      }
      this.formatDropdownChoices()
    },

    async manageMultipleUser() {
      await File.patch(this.actualFile.id, { data: this.actualFile })
      if (this.actualFile.shared_users.indexOf(this.userMe) < 0) {
        this.$delete(
          this.folder.folders[this.folder.folders.findIndex((folder) => folder.label === 'shared')].files,
          this.folder.folders[this.folder.folders.findIndex((folder) => folder.label === 'shared')].files.findIndex(
            (file) => file.id === this.actualFile.id,
          ),
        )
      } else {
        this.folder.folders[this.folder.folders.findIndex((folder) => folder.label === 'shared')].files.push(
          this.actualFile,
        )
      }
    },

    async addRemoveFav(fileId) {
      const allFolderIndex = this.folder.folders.findIndex((folder) => folder.label === 'all')
      const favFolderIndex = this.folder.folders.findIndex((folder) => folder.label === 'fav')
      const allFolderFileIndex = this.folder.folders[allFolderIndex].files.findIndex((file) => file.id === fileId)

      if (this.folder.folders[allFolderIndex].files[allFolderFileIndex].favorite_users.indexOf(this.userMe) >= 0) {
        this.$delete(
          this.folder.folders[allFolderIndex].files[allFolderFileIndex].favorite_users,
          this.folder.folders[allFolderIndex].files[allFolderFileIndex].favorite_users.indexOf(this.userMe),
        )
        this.$delete(
          this.folder.folders[favFolderIndex].files,
          this.folder.folders[favFolderIndex].files.findIndex((file) => file.id === fileId),
        )
      } else {
        this.folder.folders[allFolderIndex].files[allFolderFileIndex].favorite_users.push(this.userMe)
        this.folder.folders[favFolderIndex].files.push(this.folder.folders[allFolderIndex].files[allFolderFileIndex])
      }

      await File.patch(this.folder.folders[allFolderIndex].files[allFolderFileIndex].id, {
        data: this.folder.folders[allFolderIndex].files[allFolderFileIndex],
      })
    },

    openShareModal() {
      this.$refs.userManagerPop.manageUserPop()
    },

    exportFile() {
      this.$refs.html2Pdf.generatePdf()
    },

    deleteFile() {
      File.delete(this.actualFile.id)
      const parentFolder = this.findFolder(this.folder.folders, this.actualFile.folder_parent)
      if (parentFolder) {
        this.$delete(
          parentFolder.folders[parentFolder.folders.findIndex((folder) => folder.id === this.actualFile.folder_parent)]
            .files,
          parentFolder.folders[
            parentFolder.folders.findIndex((folder) => folder.id === this.actualFile.folder_parent)
          ].files.findIndex((file) => file.id === this.actualFile.id),
        )
      }

      for (let i = 0; i < this.folder.folders.length; i++) {
        if (
          this.folder.folders[i].default &&
          this.folder.folders[i].files.findIndex((file) => file.id === this.actualFile.id)
        ) {
          this.$delete(
            this.folder.folders[i].files,
            this.folder.folders[i].files.findIndex((file) => file.id === this.actualFile.id),
          )
        }
      }
      this.actualFile = null
    },

    findFolder(folders, folderId) {
      for (let i = 0; i < folders.length; i++) {
        if (
          folders[i].folders &&
          folders[i].folders.length &&
          folders[i].folders.findIndex((folder) => folder.id === folderId) < 0
        ) {
          return this.findFolder(folders[i].folders, folderId)
        }
        if (
          folders[i].folders &&
          folders[i].folders.length &&
          folders[i].folders.findIndex((folder) => folder.id === folderId) >= 0
        ) {
          // find if the folder is in the current folder
          return folders[i]
        }
      }
      return false // the folder that we need to find is in the route folder
    },

    async deleteFolder(folderId) {
      await Folder.delete(folderId)
      const parentFolder = this.findFolder(this.folder.folders, folderId)
      if (!parentFolder) {
        // when we are in the root folder
        this.$delete(
          this.folder.folders,
          this.folder.folders.findIndex((folder) => folder.id === folderId),
        )
      } else {
        // when in a nested folder
        this.$delete(
          parentFolder.folders,
          parentFolder.folders.findIndex((folder) => folder.id === folderId),
        )
      }
    },

    prepareEditFolder(folderId) {
      const parentFolder = this.findFolder(this.folder.folders, folderId)
      if (parentFolder) {
        this.folderForm = parentFolder.folders.find((folder) => folder.id === folderId)
      } else {
        this.folderForm = this.folder.folders.find((folder) => folder.id === folderId)
      }
      this.sliderActive = true
    },

    async editFile() {
      await File.patch(this.actualFile.id, { data: this.actualFile })
    },
  },
}
</script>

<style lang="scss">
.ck-editor__editable {
  max-height: 5px;
}

.no-notes {
  background: rgba(232, 144, 80, 0.1);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .title {
    color: #e89050;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}

.no-notes.documents {
  background-color: #f9f9ff;

  .title {
    color: #93a7d9;
  }
}

.html-to-pdf-section {
  h1 {
    word-spacing: 4px;
  }

  h2 {
    word-spacing: 2px;
  }

  h3 {
    word-spacing: 2px;
  }
}
</style>
